import { render, staticRenderFns } from "./VUserRole.vue?vue&type=template&id=22e1ad93&scoped=true"
import script from "./VUserRole.vue?vue&type=script&setup=true&lang=ts"
export * from "./VUserRole.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VUserRole.vue?vue&type=style&index=0&id=22e1ad93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1ad93",
  null
  
)

export default component.exports